/**
 * Generated runtime TestId mirror for frontend/src/features/service-accounts/components/RevokeApiKeyDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const RevokeApiKeyDialogTestIds = {
  btnCancelRevokeKey: "btn-cancel-revoke-key",
  btnConfirmRevokeKey: "btn-confirm-revoke-key",
  revokeDialogBody: "revoke-dialog-body",
  revokeDialogTitle: "revoke-dialog-title"
} as const;
